import { useState, useRef, forwardRef, useImperativeHandle, useCallback } from "react"
import ScannerInputStyled from "./ScannerInput.styled"
import { IActionScannerInput, IScannerInput } from "interfaces/IScannerInput"
import { ButtonStyled } from "theme/common/Button.styled"
import { IconSpinner, IconBarcode } from "theme/common/Icon.styled"

const ScannerInput = forwardRef<IActionScannerInput, IScannerInput>(
  (
    {
      onClickConfirmScanner,
      loadingValidateSerial,
      labelButton = "Ingresar serial",
      placeholderInput = "Esperando lectura del escaner",
      variant = "primary",
      isBarcodeMode = false,
      icon = <IconBarcode />,
    },
    ref,
  ) => {
    const refInput = useRef<HTMLInputElement>(null)
    const [textScanner, setTextScanner] = useState("")
    const [expandInputScanner, setExpandInputScanner] = useState(false)
    const [forceActive, setForceActive] = useState(false)

    const expandInput = useCallback(() => setExpandInputScanner(true), [])

    useImperativeHandle(
      ref,
      () => ({
        collapseInput: () => {
          setExpandInputScanner(false)
          setForceActive(false)
        },
        expandInput,
        focus: () => refInput.current?.focus(),
        setForceActive: (val: boolean) => setForceActive(val),
      }),
      [expandInput],
    )

    const handleClickSacannerInput = () => {
      // If we're already expanded in barcode mode, just re-focus the target input
      if (expandInputScanner && isBarcodeMode) {
        refInput.current?.focus()
        return
      }
      
      expandInput()
      refInput.current?.focus()
      if (textScanner) {
        onClickConfirmScanner(textScanner)
        setTextScanner("")
      }
    }

    const handleChangeScannerInput = (ev: React.ChangeEvent<HTMLInputElement>) => {
      setTextScanner(ev.target.value)
    }

    const handlekeyUp = (ev: React.KeyboardEvent<HTMLInputElement>) => {
      if (ev.key === "Enter" && textScanner) {
        onClickConfirmScanner(textScanner)
        setTextScanner("")
      }
    }

    return (
      <ScannerInputStyled 
        expand={expandInputScanner} 
        variant={variant} 
        isActive={Boolean(textScanner) || forceActive}
        isBarcodeMode={isBarcodeMode}
      >
        <ButtonStyled
          className="btn-scanner-text"
          variant="back"
          onClick={handleClickSacannerInput}
          title={expandInputScanner && textScanner && !isBarcodeMode ? "Confirmar ingreso de código" : undefined}
          style={isBarcodeMode && expandInputScanner ? { cursor: 'default' } : undefined}
        >
          {!expandInputScanner && icon}
          {!expandInputScanner ? (
            <span>{labelButton}</span>
          ) : isBarcodeMode ? (
            <span>{placeholderInput || "Esperando códigos..."}</span>
          ) : !loadingValidateSerial ? (
            <span>Aceptar</span>
          ) : (
            <IconSpinner variant="big" />
          )}
        </ButtonStyled>
        <input
          className="scanner-text"
          type="text"
          value={textScanner}
          onChange={handleChangeScannerInput}
          onKeyPress={handlekeyUp}
          placeholder={isBarcodeMode ? "" : placeholderInput}
          ref={refInput}
        />
      </ScannerInputStyled>
    )
  },
)

export default ScannerInput
